<template>
    <div class="download-as-csv" @click="unparseAndDownloadCsv">
        <b-button>{{ label }}</b-button>
    </div>
</template>

<script>
import { unparse } from 'papaparse';
import _ from 'lodash';

export default {
    name: "DownloadAsCsvButton",
    props: {
        quotes: {
            type: Boolean,
            default: true
        },
        fileName : {
            type: String,
            default: "data"
        },
        quoteChar: {
            type: String,
            default: '"'
        },
        delimiter: {
            type: String,
            default: ","
        },
        skipEmptyLines: {
            type: Boolean,
            default: true
        },
        escapeChar: {
            type: String,
            default: '"'
        },
        content: {
            type: Array,
            default: () => ([])
        },
        headers: {
            type: Array
        },
        label: {
            type: String,
            default: "Descarga CSV"
        }
    },
    methods: {
        unparseAndDownloadCsv() {
            let configs = {
                quotes: this.quotes,
                quoteChar: this.quoteChar,
                delimiter: this.delimiter,
                skipEmptyLines: this.skipEmptyLines,
                escapeChar: this.escapeChar
            }

            let columns = [],
                content = [];

            _.forEach(this.headers, header => {
                if(typeof header === 'string'){
                    columns.push(header);
                } else if(typeof header === 'object' && header.key){
                    columns.push(header.key);
                }
            });

            _.map(this.content, item => {
                let orderedItem = {};
                _.forEach(this.headers, header => {
                    let key,
                        fKey;
                    if(header.label && header.key){
                        fKey  = header.label;
                        key = header.key;
                    } else if(header.key){
                        key  = fKey = header.key;
                    } else {
                        key = fKey = header;
                    }
                    orderedItem[fKey] = item[key];
                });
                content.push(orderedItem);
            });

            console.log(content,  columns, this.headers);
            
            // return;
            const csv = unparse(content, configs);

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

            const link = document.createElement("a");

            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", this.fileName + ".csv");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
}
</script>